<template>
	<div class="tag-dots-expandable">
		<o-chips
			v-for="(tag, index) in setup.formattedTags"
			:key="index"
			class="tag-dots-expandable__dot"
			size="sm"
			:color="tag.color">
			<span class="tag-dots-expandable__name">
				{{ tag.name }}
			</span>
		</o-chips>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedTagDotsExpandableEmits, SharedTagDotsExpandableProps } from './SharedTagDotsExpandableSetup';
import SharedTagDotsExpandableSetup from './SharedTagDotsExpandableSetup';
const emits = defineEmits<SharedTagDotsExpandableEmits>() as SharedTagDotsExpandableEmits;
const props = withDefaults(defineProps<SharedTagDotsExpandableProps>(), SharedTagDotsExpandableSetup.defaultProps);
const setup = new SharedTagDotsExpandableSetup(props, emits);
// #endregion
</script>
